// Whether the person-picker dialog ("who is this?") shows the extra right-hand panel with a
// zoomed crop of the marker rectangle and suggested-person hints, when picking a person for a
// manually drawn face marker. Persisted like the other face-detection settings: cached in
// localStorage for synchronous access, with the canonical value synced to the server.

const SPLIT_VIEW_KEY = 'radish-person-picker-split-view-enabled';

let _splitViewEnabled = localStorage.getItem(SPLIT_VIEW_KEY) === 'true';

export function getPersonPickerSplitViewEnabled(): boolean {
  return _splitViewEnabled;
}

export function setPersonPickerSplitViewEnabled(value: boolean): void {
  _splitViewEnabled = value;
  localStorage.setItem(SPLIT_VIEW_KEY, String(value));
}
